import { useReveal } from '../hooks/useReveal';

const variants = {
  up:    { hidden: 'opacity-0 translate-y-8',   shown: 'opacity-100 translate-y-0' },
  down:  { hidden: 'opacity-0 -translate-y-8',  shown: 'opacity-100 translate-y-0' },
  left:  { hidden: 'opacity-0 -translate-x-8',  shown: 'opacity-100 translate-x-0' },
  right: { hidden: 'opacity-0 translate-x-8',   shown: 'opacity-100 translate-x-0' },
  scale: { hidden: 'opacity-0 scale-[0.94]',    shown: 'opacity-100 scale-100' },
  fade:  { hidden: 'opacity-0',                  shown: 'opacity-100' },
};

const Reveal = ({
  as: Tag = 'div',
  variant = 'up',
  delay = 0,
  duration = 700,
  className = '',
  children,
  ...rest
}) => {
  const [ref, visible] = useReveal();
  const v = variants[variant] || variants.up;
  return (
    <Tag
      ref={ref}
      className={`will-change-transform transition-all ease-out ${
        visible ? v.shown : v.hidden
      } ${className}`}
      style={{ transitionDuration: `${duration}ms`, transitionDelay: `${delay}ms` }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
